import usePageState from '@/context/pageStates/pageStateHook';
import { useLayoutEffect } from 'react';

function usePageScrollHold({ key, id, pageContainerRef } = {}) {
    const pagesStates = usePageState();

    useLayoutEffect(() => {
        let pageState;
        if (id) {
            /* for dynamic pages */
            if (!pagesStates[key].current.id) {
                pagesStates[key].current.id = {};
            }
            pageState = pagesStates[key].current.id;
        } else {
            /* for static pages */
            pageState = pagesStates[key].current;
        }

        if (pageState.scrollPosition && pageContainerRef) {
            pageContainerRef.current.scrollTop = pageState.scrollPosition;
        }
        return () => {
            pageState.scrollPosition = pageContainerRef.current?.scrollTop;
        };
    }, []);

    return {};
}

export default usePageScrollHold;
